<template>
    <div :class="['password v-alert-container',{ 'v-background': background },{ 'off-top': !show },{ error: error }]">
        <div class="v-alert">
            <header><p>Login</p><div class="x" @click="exit(false)"></div></header>
            <label>
                <p>Username</p>
                <input />
            </label>
            <label>
                <p>Password</p>
                <input />
            </label>
            <div class="v-btns">
                <p class="btn gr">cancel</p>
                <p class="btn">OK</p>
            </div>	
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            background: true,
            show: false,
            error: false
        }
    },
    mounted () {
        setTimeout(() => {
            this.show = true;
        });
    },
    methods: {
        exit ( resp ) {
            this.$emit('exit',resp);
        }
    }
}

</script>

<style>

</style>